// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"rc2sRjx","ratingContainer":"rc2sRjx","rating":"Swy31HP","score":"V4FAPi5","star":"h2sLcDt","count":"YA9ZNSn"};